export const environment = {
  envName: 'prod',
  production: true,

  /*
  Доступные логотипы:
  - bdc.png
  - tta_light.svg
  - tta_dark.svg
   */
  logoFileName: "bdc.png",
  logoHeader: "Blockchain Digital Capital",

  apiUrl: 'https://custody.bdcap.live:444/',
  tokenUrl: 'https://custody.bdcap.live:444/connect/token',

  networkType: 'prod',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts